<glxy-uploader
  [autoUpload]="true"
  [uploadUrl]="attachmentsUploadUrl"
  [maxFiles]="100"
  [files]="files$ | async"
  (fileUploadErrored)="handleFileUploadError($event)"
  (fileUploaded)="uploadFile($event)"
></glxy-uploader>
<div *ngIf="files$ | async as files">
  <glxy-uploader-list [files]="files"></glxy-uploader-list>
</div>
